<template>
<ol id="bc" itemscope itemtype="http://schema.org/BreadcrumbList">
    <li itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem">
        <router-link itemprop="item" :to="`/`"><span itemprop="name">Strona główna</span></router-link>
        <span itemprop="position" content="1">&gt;</span>
    </li>
    <li itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem" v-if="breadcrumbs.parent_title">
        <router-link itemprop="item" :to="breadcrumbs.parent_uri"><span itemprop="name">{{breadcrumbs.parent_title}}</span></router-link>
        <span itemprop="position" content="2"></span>
    </li>
    <li itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem" v-if="breadcrumbs.self_title">
        <a itemprop="item" :href="breadcrumbs.parent_uri">
            <span itemprop="name">{{breadcrumbs.self_title}}</span>
        </a>
        <span itemprop="position" content=""></span>
    </li>
</ol>
</template>
<script>

export default {
  name: 'Breadcrumbs',
  props: ['breadcrumbs'],
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  watch: {
      $props: {
        immediate: true, 
        deep: true,
        handler(v) {
          //this.$emit('updateHead')
          //this.meta.og_image = meta.og_image
        }
      }
    }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Common/Breadcrumbs.vue